import { CometChatUIKit } from "@cometchat/chat-uikit-react";
import { saveUserDetails } from "../store/slices/common";

export async function loginUser(resData, dispatch) {
    try {
      CometChatUIKit.login(resData?.cometChat?.uid)
        ?.then((loggedInUser) => {
          if (loggedInUser)
            dispatch(
              saveUserDetails({
                ...resData.profile,
                status: loggedInUser.status,
                ...(resData.cometChat ? resData.cometChat : {}),
              })
            );
        })
        .catch(() => {});
    } catch (error) {
      console.log(error);
    } finally {
      // handle comet chat login response
    }
  }